// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"2a72ad23","285":"16132900","315":"00b8f905","330":"77374501","434":"9318ba52","497":"87a69330","678":"72aefaa5"}[chunkId] + ".chunk.js";
};